import React from "react";
import { debounce } from 'lodash';
import DebtCalculator from './DebtCalculator';
import CalculatorSliders from '../CalculatorSliders';
import CalculatorResults from '../CalculatorResults';
import '../Calculator.css';
import './CalculatorAdvanced.css';

function CalculatorAdvanced() {
  const DEFAULT_DEBT = 25000;
  const DEFAULT_DEBT_APR = 22;
  const DEFAULT_DEBT_CONSOLIDATION_APR = 15;
  const DEFAULT_SERA_APR = 15;
  const DEFAULT_MONTHLY_INCOME = 5000;
  const DEFAULT_MONTHLY_NON_CC_EXPENSES = 2000;
  const DEFAULT_MONTHLY_NON_CC_EXPENSES_DEDUCTION_DOM = 1;
  const DEFAULT_MONTHLY_PAYMENT = 800;
  const DEFAULT_MONTHLY_SAVINGS = 100;

  const DEFAULT_SERA_PERCENTAGE_FEES = 10;
  const DEFAULT_SERA_FLAT_FEES = 5;
  const DEFAULT_USE_SERA_BASIC_FLAT_FEES = true;
  const DEFAULT_USE_SERA_SOLO_FLAT_FEES = false;

  const debtRef = React.useRef();
  const debtAPRRef = React.useRef();
  const debtConsolidationAPRRef = React.useRef();
  const seraAPRRef = React.useRef();
  const monthlyIncomeRef = React.useRef();
  const monthlyNonCCExpensesRef = React.useRef();
  const nonCCExpensesDeductionDOMRef = React.useRef();
  const monthlyPaymentRef = React.useRef();
  const monthlySavingsRef = React.useRef();
  
  const useSeraBasicFlatFeesRef = React.useRef(DEFAULT_USE_SERA_BASIC_FLAT_FEES);
  const seraBasicPercentageFeesRef = React.useRef();
  const seraBasicFlatFeesRef = React.useRef();
  const useSeraSoloFlatFeesRef = React.useRef(DEFAULT_USE_SERA_SOLO_FLAT_FEES);
  const seraSoloPercentageFeesRef = React.useRef();
  const seraSoloFlatFeesRef = React.useRef();

  const hasInputErrorRef = React.useRef(false);

  const useCCRef = React.useRef();

  const [withSeraBasicAmount, setWithSeraBasicAmount] = React.useState(3300);
  const [withSeraBasicMonths, setWithSeraBasicMonths] = React.useState(19);
  const [withSeraBasicPaymentsSchedule, setWithSeraBasicPaymentsSchedule] = React.useState([]);

  const [withSeraAmount, setWithSeraAmount] = React.useState(3300);
  const [withSeraMonths, setWithSeraMonths] = React.useState(19);
  const [withSeraSoloPaymentsSchedule, setWithSeraSoloPaymentsSchedule] = React.useState([]);

  const [withConsolidationMonths, setWithConsolidationMonths] = React.useState(44);
  const [withConsolidationAmount, setWithConsolidationAmount] = React.useState(7300);
  const [withConsolidationPaymentsSchedule, setWithConsolidationPaymentsSchedule] = React.useState([]);

  const [withoutHelpMonths, setWithoutHelpMonths] = React.useState(52);
  const [withoutHelpAmount, setWithoutHelpAmount] = React.useState(14400);
  const [withoutHelpPaymentsSchedule, setWithoutHelpPaymentsSchedule] = React.useState([]);

  /*const [currentDebtValue, setCurrentDebtValue] = React.useState(25000);
  const [currentMonthlyIncomeValue, setCurrentMonthlyIncomeValue] = React.useState(5000);
  const [currentMonthlyPaymentValue, setCurrentMonthlyPaymentValue] = React.useState(800);
  const [currentMonthlySavingsValue, setCurrentMonthlySavingsValue] = React.useState(100);*/

  const [minimumMonthlyPayment, setMinimumMonthlyPayment] = React.useState(DEFAULT_MONTHLY_PAYMENT);
  const [monthlyPayment, setMonthlyPayment] = React.useState(DEFAULT_MONTHLY_PAYMENT);
  const [hasMinimumPaymentError, setHasMinimumPaymentError] = React.useState(false);

  const [activePaymentsScheduleTab, setActivePaymentsScheduleTab] = React.useState(0);

  const getMinMonthlyPayment = (debtBalance, debtAPR) => {
    const yearlyInterest = debtBalance * (debtAPR + 0.1);
    const monthlyInterest = yearlyInterest / 12;
    const roundedMonthlyInterest = Math.ceil(monthlyInterest / 100) * 100;
    return Math.round(roundedMonthlyInterest);
  }

  const fetchCalculation = React.useCallback(
    debounce((debt, debtAPR, debtConsolidationAPR, seraAPR, monthlyIncome, monthlyNonCCExpenses, nonCCExpensesDeductionDOM, monthlyPayment, monthlySavings, useSeraBasicFlatFees, seraBasicFlatFees, seraBasicPercentageFees, useSeraSoloFlatFees, seraSoloFlatFees, seraSoloPercentageFees, useCC) => doCalculation(debt, debtAPR, debtConsolidationAPR, seraAPR, monthlyIncome, monthlyNonCCExpenses, nonCCExpensesDeductionDOM, monthlyPayment, monthlySavings, useSeraBasicFlatFees, seraBasicFlatFees, seraBasicPercentageFees, useSeraSoloFlatFees, seraSoloFlatFees, seraSoloPercentageFees, useCC), 500), []
  );

  const doCalculation = (debt, debtAPR, debtConsolidationAPR, seraAPR, monthlyIncome, monthlyNonCCExpenses, nonCCExpensesDeductionDOM, monthlyPayment, monthlySavings, useSeraBasicFlatFees, seraBasicFlatFees, seraBasicPercentageFees, useSeraSoloFlatFees, seraSoloFlatFees, seraSoloPercentageFees, useCC) => {

    setMinimumMonthlyPayment(getMinMonthlyPayment(debt, debtAPR/100));
    setMonthlyPayment(parseInt(monthlyPaymentRef.current.value));
    setHasMinimumPaymentError(hasInputErrorRef.current);      

    if (hasInputErrorRef.current === true) {
      console.log('input error');
      return;
    }

    console.log('************************** debt: ' + debt + ', debtAPR: ' + debtAPR + ', debtConsolidationAPR: ' + debtConsolidationAPR + ', seraAPR: ' + seraAPR + ', monthlyIncome: ' + monthlyIncome + ', monthlyNonCCExpenses: ' + monthlyNonCCExpenses + ', monthlyPayment: ' + monthlyPayment + ', monthlySavings: ' + monthlySavings + ', useSeraSoloFlatFees: ' + useSeraSoloFlatFees + ', seraSoloFlatFees: ' + seraSoloFlatFees + ', seraSoloPercentageFees: ' + seraSoloPercentageFees);

    let resultStd = DebtCalculator.computeDebtStd(debt, debtAPR/100, monthlyPayment);
    setWithoutHelpMonths(resultStd.numMonthlyPayments);
    setWithoutHelpAmount(resultStd.totalInterestPaid);
    setWithoutHelpPaymentsSchedule(resultStd.paymentsSchedule);

    let resultDebtConsolidation = DebtCalculator.computeDebtStd(debt, debtConsolidationAPR/100, monthlyPayment);
    setWithConsolidationMonths(resultDebtConsolidation.numMonthlyPayments);
    setWithConsolidationAmount(resultDebtConsolidation.totalInterestPaid);
    setWithConsolidationPaymentsSchedule(resultDebtConsolidation.paymentsSchedule);

    let resultSeraBasic = DebtCalculator.computeDebtSeraBasic(debt, debtAPR/100, monthlyIncome, monthlyNonCCExpenses, monthlyPayment, monthlySavings, useSeraBasicFlatFees, seraBasicFlatFees, seraBasicPercentageFees);
    setWithSeraBasicMonths(resultSeraBasic.numMonthlyPayments);
    setWithSeraBasicAmount(resultSeraBasic.totalInterestPaid);
    setWithSeraBasicPaymentsSchedule(resultSeraBasic.paymentsSchedule);

    let resultSeraSolo = DebtCalculator.computeDebtSeraSolo(debt, seraAPR/100, debtAPR/100, monthlyIncome, monthlyNonCCExpenses, nonCCExpensesDeductionDOM, monthlyPayment, monthlySavings, useSeraSoloFlatFees, seraSoloFlatFees, seraSoloPercentageFees, useCC);
    setWithSeraMonths(resultSeraSolo.numMonthlyPayments);
    setWithSeraAmount(resultSeraSolo.totalInterestPaid);
    setWithSeraSoloPaymentsSchedule(resultSeraSolo.paymentsSchedule);

  }

  const sliderOnChange = () => {
      if (debtRef.current && debtAPRRef.current && debtConsolidationAPRRef.current && seraAPRRef.current && monthlyIncomeRef.current && monthlyNonCCExpensesRef.current && nonCCExpensesDeductionDOMRef.current && monthlyPaymentRef.current && monthlySavingsRef.current && useSeraBasicFlatFeesRef.current && seraBasicFlatFeesRef.current && seraBasicPercentageFeesRef.current && useSeraSoloFlatFeesRef.current && seraSoloFlatFeesRef.current && seraSoloPercentageFeesRef && useCCRef.current) {
        fetchCalculation(parseInt(debtRef.current.value), parseInt(debtAPRRef.current.value), parseInt(debtConsolidationAPRRef.current.value), parseInt(seraAPRRef.current.value), parseInt(monthlyIncomeRef.current.value), parseInt(monthlyNonCCExpensesRef.current.value), parseInt(nonCCExpensesDeductionDOMRef.current.value), parseInt(monthlyPaymentRef.current.value), parseInt(monthlySavingsRef.current.value), useSeraBasicFlatFeesRef.current.checked, parseInt(seraBasicFlatFeesRef.current.value), parseInt(seraBasicPercentageFeesRef.current.value), useSeraSoloFlatFeesRef.current.checked, parseInt(seraSoloFlatFeesRef.current.value), parseInt(seraSoloPercentageFeesRef.current.value), useCCRef.current.checked);
      }
  }

  React.useEffect(() => {
    fetchCalculation(DEFAULT_DEBT, DEFAULT_DEBT_APR, DEFAULT_DEBT_CONSOLIDATION_APR, DEFAULT_SERA_APR, DEFAULT_MONTHLY_INCOME, DEFAULT_MONTHLY_NON_CC_EXPENSES, DEFAULT_MONTHLY_NON_CC_EXPENSES_DEDUCTION_DOM, DEFAULT_MONTHLY_PAYMENT, DEFAULT_MONTHLY_SAVINGS, DEFAULT_USE_SERA_BASIC_FLAT_FEES, DEFAULT_SERA_FLAT_FEES, DEFAULT_SERA_PERCENTAGE_FEES, DEFAULT_USE_SERA_SOLO_FLAT_FEES, DEFAULT_SERA_FLAT_FEES, DEFAULT_SERA_PERCENTAGE_FEES);
  }, [fetchCalculation]);

  const getTotalInterestPaid = (paymentsSchedule) => {
    if (!paymentsSchedule || paymentsSchedule.length === 0 || (!paymentsSchedule[0].locInterest && !paymentsSchedule[0].interest)) {
      return 0;
    }
    if (paymentsSchedule[0].locInterest !== undefined) {
      return parseInt(paymentsSchedule.reduce((n, {locInterest}) => n + Number(locInterest), 0));
    }
    return parseInt(paymentsSchedule.reduce((n, {interest}) => n + Number(interest), 0));
  }

  const getTotalInterestStdPaid = (paymentsSchedule) => {
    if (!paymentsSchedule || paymentsSchedule.length === 0 || !paymentsSchedule[0].locInterestStd) {
      return 0;
    }
    return parseInt(paymentsSchedule.reduce((n, {locInterestStd}) => n + Number(locInterestStd), 0));
  }

  const getTotalDailyInterestPaid = (paymentsSchedule) => {
    if (!paymentsSchedule || paymentsSchedule.length === 0 || !paymentsSchedule[0].dailyInterest) {
      return 0;
    }
    return parseInt(paymentsSchedule.reduce((n, {dailyInterest}) => n + Number(dailyInterest), 0));
  }

  const getTotalDailyRegularInterestPaid = (paymentsSchedule) => {
    if (!paymentsSchedule || paymentsSchedule.length === 0 || !paymentsSchedule[0].dailyInterestRegular) {
      return 0;
    }
    return parseInt(paymentsSchedule.reduce((n, {dailyInterestRegular}) => n + Number(dailyInterestRegular), 0));
  }

  const getTotalFees = (paymentsSchedule) => {
    if (!paymentsSchedule || paymentsSchedule.length === 0 || paymentsSchedule[0].fees === null) {
      return 0;
    }
    return parseInt(paymentsSchedule.reduce((n, {fees}) => n + Number(fees), 0));
  }

  const getTotalMonths = (paymentsSchedule) => {
    if (!paymentsSchedule || paymentsSchedule.length === 0) {
      return 0;
    }
    return [...new Set(paymentsSchedule.map(item => item.month))].length;
  }


  return (
    <React.Fragment>
      <div className='calculator-container advanced'>
        
        <CalculatorSliders debtRef={debtRef} debtAPRRef={debtAPRRef} debtConsolidationAPRRef={debtConsolidationAPRRef} seraAPRRef={seraAPRRef} monthlyIncomeRef={monthlyIncomeRef} monthlyNonCCExpensesRef={monthlyNonCCExpensesRef} nonCCExpensesDeductionDOMRef={nonCCExpensesDeductionDOMRef} monthlyPaymentRef={monthlyPaymentRef} monthlySavingsRef={monthlySavingsRef} useSeraBasicFlatFeesRef={useSeraBasicFlatFeesRef} seraBasicPercentageFeesRef={seraBasicPercentageFeesRef} seraBasicFlatFeesRef={seraBasicFlatFeesRef} useSeraSoloFlatFeesRef={useSeraSoloFlatFeesRef} seraSoloPercentageFeesRef={seraSoloPercentageFeesRef} seraSoloFlatFeesRef={seraSoloFlatFeesRef} hasInputErrorRef={hasInputErrorRef} onChange={sliderOnChange} defaultDebtValue={DEFAULT_DEBT} defaultDebtAPRValue={DEFAULT_DEBT_APR} defaultDebtConsolidationAPRValue={DEFAULT_DEBT_CONSOLIDATION_APR} defaultSeraAPRValue={DEFAULT_SERA_APR} defaultMonthlyIncomeValue={DEFAULT_MONTHLY_INCOME} defaultMonthlyNonCCExpensesValue={DEFAULT_MONTHLY_NON_CC_EXPENSES} defaultNonCCExpensesDeductionDOMValue={DEFAULT_MONTHLY_NON_CC_EXPENSES_DEDUCTION_DOM} defaultMonthlyPaymentValue={DEFAULT_MONTHLY_PAYMENT} defaultMonthlySavingsValue={DEFAULT_MONTHLY_SAVINGS} defaultUseSeraBasicFlatFeesValue={DEFAULT_USE_SERA_BASIC_FLAT_FEES} defaultUseSeraSoloFlatFeesValue={DEFAULT_USE_SERA_SOLO_FLAT_FEES} defaultSeraPercentageFeesValue={DEFAULT_SERA_PERCENTAGE_FEES} defaultSeraFlatFeesValue={DEFAULT_SERA_FLAT_FEES} isAdvanced={true} />
        
        <CalculatorResults isAdvanced={true} withConsolidationAmount={withConsolidationAmount} withConsolidationMonths={withConsolidationMonths} withoutHelpAmount={withoutHelpAmount} withoutHelpMonths={withoutHelpMonths} withSeraBasicAmount={withSeraBasicAmount} withSeraBasicMonths={withSeraBasicMonths} withSeraAmount={withSeraAmount} withSeraMonths={withSeraMonths} monthlyPayment={monthlyPayment} minimumMonthlyPayment={minimumMonthlyPayment} hasMinimumPaymentError={hasMinimumPaymentError} />
        
      </div>

      <div className='cc-container tooltip-container'>
        <p className='title'>Use credit card for expenses 
          <input ref={useCCRef} type="checkbox" defaultChecked={true} onChange={sliderOnChange} />
        </p>
      </div>

      <div className='payment-details'>
        <ul>
          <li><button className={activePaymentsScheduleTab === 0 ? 'active' : ''} onClick={() => setActivePaymentsScheduleTab(0)}>Sera Basic</button></li>
          <li><button className={activePaymentsScheduleTab === 1 ? 'active' : ''} onClick={() => setActivePaymentsScheduleTab(1)}>Sera Solo</button></li>
          <li><button className={activePaymentsScheduleTab === 2 ? 'active' : ''} onClick={() => setActivePaymentsScheduleTab(2)}>Debt consolidation</button></li>
          <li><button className={activePaymentsScheduleTab === 3 ? 'active' : ''} onClick={() => setActivePaymentsScheduleTab(3)}>No help</button></li>
        </ul>

        {activePaymentsScheduleTab === 0 && (
          <table>
            <thead>
          <tr>
            <th>Months<br/>({getTotalMonths(withSeraBasicPaymentsSchedule)})</th>
            <th>Days<br/>so far</th>
            <th>Day of<br/>month</th>
            <th>Debt start<br/>balance regular</th>
            <th>Debt start<br/>balance offset</th>
            <th>Checking start<br/>balance</th>
            <th>Income</th>
            <th>Savings</th>
            <th>Payment</th>
            <th>Deducted non<br/>CC Expenses</th>
            <th>Remaining non<br/>CC Expenses</th>
            <th>Expenses</th>
            <th>Fees</th>
            <th>Debt end<br/>balance regular</th>
            <th>Debt end<br/>balance offset</th>
            <th>Checking end<br/>balance</th>
            <th>Interest<br/>{`($${getTotalDailyInterestPaid(withSeraBasicPaymentsSchedule).toLocaleString()})`}</th>
            <th>Interest Regular<br/>{`($${getTotalDailyRegularInterestPaid(withSeraBasicPaymentsSchedule).toLocaleString()})`}</th>
          </tr>
          </thead>
          <tbody>
          {
            withSeraBasicPaymentsSchedule.map(( item, index ) => {
            return (
              <tr key={index}>
                <td>{item.month}</td>
                <td>{item.daysSoFar}</td>
                <td>{item.dayOfMonth}</td>
                <td>${item.debtBalanceRegularStart.toLocaleString()}</td>
                <td>${item.debtBalanceStart.toLocaleString()}</td>
                <td>${item.checkingBalanceStart.toLocaleString()}</td>
                <td>${item.income.toLocaleString()}</td>
                <td>${item.savings.toLocaleString()}</td>
                <td>${item.payment.toLocaleString()}</td>
                <td>${item.deductedNonCCExpenses.toLocaleString()}</td>
                <td>${item.remainingNonCCExpenses.toLocaleString()}</td>
                <td>${item.expenses.toLocaleString()}</td>
                <td>${item.fees.toLocaleString()}</td>
                <td>${item.debtBalanceRegularEnd.toLocaleString()}</td>
                <td>${item.debtBalanceEnd.toLocaleString()}</td>
                <td>${item.checkingBalanceEnd.toLocaleString()}</td>
                <td>${item.dailyInterest.toLocaleString()}</td>
                <td>${item.dailyInterestRegular.toLocaleString()}</td>
              </tr>
            );
          })}
            </tbody>
          </table>
        )}

        {activePaymentsScheduleTab === 1 && (
          <table>
            <thead>
          <tr>
            <th>Months<br/>({getTotalMonths(withSeraSoloPaymentsSchedule)})</th>
            <th>Days<br/>so far</th>
            <th>Day of<br/>month</th>
            <th>Debt start<br/>balance</th>
            <th>Checking start<br/>balance</th>
            <th>Savings start<br/>balance</th>
            <th>Deducted non<br/>CC Expenses</th>
            <th>Remaining non<br/>CC Expenses</th>
            <th>Expenses</th>
            <th>Income</th>
            <th>Savings</th>
            <th>Payment</th>
            <th>Debt end<br/>balance</th>
            <th>Checking end<br/>balance</th>
            <th>Savings end<br/>balance</th>
            <th>Offset debt<br/>balance</th>
            <th>Interest<br/>{`($${getTotalInterestPaid(withSeraSoloPaymentsSchedule).toLocaleString()})`}</th>
            <th>Interest<br/>standard<br/>{`($${getTotalInterestStdPaid(withSeraSoloPaymentsSchedule).toLocaleString()})`}</th>
            <th>Interest<br/>offset</th>
            <th>Fees<br/>{`($${getTotalFees(withSeraSoloPaymentsSchedule).toLocaleString()})`}</th>
          </tr>
          </thead>
          <tbody>
          {
            withSeraSoloPaymentsSchedule.map(( item, index ) => {
            return (
              <tr key={index}>
                <td>{item.month}</td>
                <td>{item.daysSoFar}</td>
                <td>{item.dayOfMonth}</td>
                <td>${item.locBalanceStart.toLocaleString()}</td>
                <td>${item.checkingBalanceStart.toLocaleString()}</td>
                <td>${item.savingsBalanceStart.toLocaleString()}</td>
                <td>${item.deductedNonCCExpenses.toLocaleString()}</td>
                <td>${item.remainingNonCCExpenses.toLocaleString()}</td>
                <td>${item.expenses.toLocaleString()}</td>
                <td>${item.income.toLocaleString()}</td>
                <td>${item.savings.toLocaleString()}</td>
                <td>${item.locPayment.toLocaleString()}</td>
                <td>${item.locBalanceEnd.toLocaleString()}</td>
                <td>${item.checkingBalanceEnd.toLocaleString()}</td>
                <td>${item.savingsBalanceEnd.toLocaleString()}</td>
                <td>${item.offsetBalance.toLocaleString()}</td>
                <td>${item.locInterest.toLocaleString()}</td>
                <td>${item.locInterestStd.toLocaleString()}</td>
                <td>${item.locInterestOffset.toLocaleString()}</td>
                <td>${item.fees.toLocaleString()}</td>
              </tr>
            );
          })}
            </tbody>
          </table>
        )}

        {activePaymentsScheduleTab === 2 && (
          <table>
          <tr>
            <th>Months<br/>({withConsolidationPaymentsSchedule.length})</th>
            <th>Starting Balance</th>
            <th>Interest<br/>{`($${getTotalInterestPaid(withConsolidationPaymentsSchedule).toLocaleString()})`}</th>
            <th>Payment</th>
            <th>Ending Balance</th>
          </tr>
          {
            withConsolidationPaymentsSchedule.map(( item, index ) => {
            return (
              <tr key={index}>
                <td>{item.month}</td>
                <td>${item.startingBalance.toLocaleString()}</td>
                <td>${item.interest.toLocaleString()}</td>
                <td>${item.payment.toLocaleString()}</td>
                <td>${item.endingBalance.toLocaleString()}</td>
              </tr>
            );
          })}
          </table>
        )}

        {activePaymentsScheduleTab === 3 && (
          <table>
              <tr>
                <th>Months<br/>({withoutHelpPaymentsSchedule.length})</th>
                <th>Starting Balance</th>
                <th>Interest<br/>{`($${getTotalInterestPaid(withoutHelpPaymentsSchedule).toLocaleString()})`}</th>
                <th>Payment</th>
                <th>Ending Balance</th>
              </tr>
          {
            withoutHelpPaymentsSchedule.map(( item, index ) => {
            return (
              <tr key={index}>
                <td>{item.month}</td>
                <td>${item.startingBalance.toLocaleString()}</td>
                <td>${item.interest.toLocaleString()}</td>
                <td>${item.payment.toLocaleString()}</td>
                <td>${item.endingBalance.toLocaleString()}</td>
              </tr>
            );
          })}
          </table>
        )}


      </div>

    </React.Fragment>
  )
}

export default CalculatorAdvanced;